var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstrelas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.172 21.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4.742,27.69,6.355l-6.055.9A1.366,1.366,0,0,0,20.9,9.572l4.381,4.366-1.036,6.168a1.332,1.332,0,0,0,1.923,1.429l5.417-2.912L37,21.534a1.333,1.333,0,0,0,1.923-1.429l-1.036-6.168L42.27,9.572a1.366,1.366,0,0,0-.734-2.314l-6.055-.9L32.775.742a1.314,1.314,0,0,0-2.379,0Z",
    transform: "translate(-20.5 0.013)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrelas);
export default __webpack_public_path__ + "static/media/estrelas.3d549fc6.svg";
export { ForwardRef as ReactComponent };